import React from "react";
import "./index.css";

const Lang = (props) => {
  return (
    <section id="LANGUAGES" className="all-sections add-flex-sections">
      <div className="languages-obseve" observe="6"></div>
      <h1 className="education-title-h">LANGUAGES</h1>
      <i className="fas fa-award">
        <p className="school-details-p milit-mar-p mar-lang-p">
          Hebrew - Native | English - Fluent
        </p>
      </i>
    </section>
  );
};

export default Lang;
